import { Component, OnInit, Input, OnDestroy } from '@angular/core';

import { UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';

import { FilterApiService } from '../../../services/api/filter-api.service';
import { RosterEventService } from '../roster-event.service';
import { FormService, TimeService, AutoUnsubscribe } from '@bayclubs/utils';
import { RosterFilter } from '../../../models/filters/roster-filter.model';


@Component({
    selector: 'app-roster-search-criteria',
    templateUrl: './roster-search-criteria.component.html',
    styleUrls: ['./roster-search-criteria.component.scss'],
    standalone: false
})
export class RosterSearchCriteriaComponent implements OnInit, OnDestroy {
    @Input()
    public searchForm: UntypedFormGroup;

    public clubs = [];

    @Input() public filters: RosterFilter;

    @AutoUnsubscribe()
    private subscriptions: Subscription[] = [];

    constructor(private filterApi: FilterApiService, private rosterEvent: RosterEventService, private time: TimeService) {}

    ngOnDestroy(): void {}

    ngOnInit() {
        this.loadFilters();
        this.subscribeToClubChanges();
    }

    public onSubmit() {
        this.rosterEvent.onSearch();
    }

    private loadFilters() {
        this.filterApi.get(false).subscribe(data => {
            if (data.isSuccess) {
                this.clubs = data.value.clubs.map(x => this.createDropdownItem(x.id, x.code, x.name));
            }
        });
    }

    private createDropdownItem(id, code, name) {
        return {
            id: id,
            code: code,
            name: name
        };
    }

    private subscribeToClubChanges() {
        this.subscriptions.push(
        this.searchForm.controls['clubId'].valueChanges.subscribe(value => {
            const selectedClub = this.clubs.find(x => x.id === value);

            if (selectedClub) {
                this.searchForm.controls['clubCode'].setValue(selectedClub.code);
            }
        }));
    }

    public isFormValid() {
        return FormService.isFormValid(this.searchForm);
    }
}
